export default {
  data: () => ({
    // The top ad goes before this row index. Index 0 is The Latest, which is
    // prepended at request time, so index N sits after the (N-1)th editorial row.
    //
    // Placed from engagement_stats (first-cell impressions per row, 14 days to
    // 2026-09-15): Email 56k, Reference 52k, Weather 43k, Social 39k, Magazines
    // 14k, Cellular 10k. The old index 18 put the ad before Cellular, where
    // under a fifth of visitors ever arrive.
    //
    // Desktop: after Weather, before Social, still inside a 900px first screen.
    // Phones: after Reference, before AI; rows are much taller there, so the
    // same view share is reached far earlier.
    TOP_AD_BEFORE_LINE_DESKTOP: 9,
    TOP_AD_BEFORE_LINE_MOBILE: 6,
    // Second unit between the rows: after Crypto, before Sports (~19-21k views
    // in the same 14 days). Further down the rows fall to 5-8k and then ~3k,
    // where Google already declined to fill the unit above the footer, so a
    // third one would add weight to the page for little money. Same index on
    // phones: it stays well clear of the top unit there.
    MIDDLE_AD_BEFORE_LINE: 15,
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    isPaidUser() {
      return this.user !== null && this.user.plan_id != null;
    },
    isPremiumUser() {
      return this.user !== null && this.user.premium != null;
    },
    isAdminUser() {
      return this.user !== null && this.user.role === 'admin';
    },
    hasSubscription() {
      return this.isPaidUser || this.isPremiumUser || this.isAdminUser;
    },
    HasNotAdsSection() {
      // check null because homepage doesn't have name
      return (this.$route.name) ? (this.$route.name.includes('user')
        || this.$route.name.includes('admin')
        || this.$route.name.includes('aboutUs')
        || this.$route.path.includes('user-settings')
        || this.$route.path.includes('bookmarklet')
        || this.$route.name.includes('privacy')
        || this.$route.name.includes('step1Login')
        || this.$route.name.includes('step2Login')
        || this.$route.name.includes('mostPopularSites')
        || this.$route.name.includes('termsConditions')) : true;
    },
  },
};
